var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSheet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 424,
    height: 512,
    viewBox: "0 0 424 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M419.996 126.864L296.192 3.061C294.232 1.101 291.574 0 288.803 0H51.7263C23.7253 0 0.944336 22.782 0.944336 50.784V461.218C0.944336 489.219 23.7253 512.001 51.7273 512.001H372.274C400.275 512.001 423.057 489.22 423.057 461.218V134.253C423.056 131.482 421.955 128.824 419.996 126.864ZM299.254 35.678H299.255L387.381 123.804H329.139C321.155 123.804 313.649 120.695 308.005 115.051C302.362 109.408 299.253 101.903 299.254 93.92V35.678V35.678ZM402.159 461.217C402.158 477.696 388.752 491.102 372.274 491.102H51.7263C35.2473 491.102 21.8413 477.696 21.8413 461.217V50.784C21.8423 34.305 35.2483 20.898 51.7263 20.898H278.357V93.919C278.355 107.484 283.637 120.237 293.229 129.828C302.82 139.42 315.574 144.702 329.14 144.702H402.159V461.217Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSheet);
export default __webpack_public_path__ + "static/media/Sheet.84dea1c71e6e9441f28eac6eed071a9f.svg";
export { ForwardRef as ReactComponent };